import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { ASSESSMENTS_ERROR, GETTING_ASSESSMENTS, GETTING_ASSESSMENT_RECORDS, GET_ASSESSMENTS, GET_ASSESSMENT_RECORDS } from "../types"

export const fetchAssessmentRecords = (studentId, filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/assessment-records/student/${studentId}?expand=student,recordedBy,class.class,academicSession,term,subject`

        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_ASSESSMENT_RECORDS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_ASSESSMENT_RECORDS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: ASSESSMENTS_ERROR,
            error
        })
    }
}

export const fetchAssessments = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/assessments?expand=term,academicSession,createdBy`

        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_ASSESSMENTS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_ASSESSMENTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: ASSESSMENTS_ERROR,
            error
        })
    }
}

